import React, { useState } from 'react';
import { Col, Row } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import ReportCard from '../../../../components/ReportCard';
import StyledNotesContainer from '../StyledNotesContainer';
import ReportNote from '../../../../components/ReportNote';

const DeliveryNotes = ({ isLhb, pitcherId, levelId }) => {
    const { t: translate } = useTranslation();

    const [hasDeliveryNote, setHasDeliveryNote] = useState(true);

    return hasDeliveryNote ? (
        <Row>
            <Col md={12}>
                <ReportCard title={translate('pitcher-overview.sections.delivery-notes')}>
                    <StyledNotesContainer>
                        { pitcherId && hasDeliveryNote && (
                            <ReportNote
                                type={levelId === 8 ? 'oppp' : 'mnhp'}
                                section={isLhb ? 252 : 251}
                                playerId={pitcherId}
                                levelId={levelId}
                                hasDataCallback={setHasDeliveryNote}
                            />
                        ) }
                    </StyledNotesContainer>
                </ReportCard>
            </Col>
        </Row>
    ) : <></>;
};

export default DeliveryNotes;
